import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import api from "../axiosConfig";
import "../styles/ForgotPassword.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const inputRef = useRef(null);

  const normalizedEmail = useMemo(() => email.trim().toLowerCase(), [email]);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    if (busy) return;

    setBusy(true);
    setError("");

    try {
      await api.post("/auth/forgot-password", {
        email: normalizedEmail,
      });
      setDone(true);
    } catch (err) {
      console.error("[forgot-password] request failed", err);
      setDone(true); // mantém UX neutra
      setError("");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="forgot-shell">
      <div className="forgot-bg" aria-hidden="true">
        <div className="forgot-bg-grid" />
        <div className="forgot-bg-glow forgot-bg-glow--a" />
        <div className="forgot-bg-glow forgot-bg-glow--b" />
      </div>

      <div className="forgot-card">
        <header className="forgot-header">
          <img
            src="/loadevo-logo.png"
            alt="LOADEvo"
            className="forgot-brand-logo"
          />
          <h1 className="forgot-title">Esqueceu-se da palavra-passe?</h1>
          <p className="forgot-subtitle">
            Introduza o seu email e enviaremos uma ligação segura para redefinir a palavra-passe.
          </p>
        </header>

        {error && (
          <div className="forgot-alert" role="alert">
            <svg viewBox="0 0 24 24" className="forgot-alert-icon" aria-hidden="true">
              <path
                d="M12 9v4m0 4h.01M10.29 3.86l-8.4 14.54A1.5 1.5 0 003.2 21h17.6a1.5 1.5 0 001.31-2.6L13.7 3.86a1.5 1.5 0 00-2.6 0z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              />
            </svg>
            <span>{error}</span>
          </div>
        )}

        {done ? (
          <div className="forgot-success" role="status">
            <div className="forgot-success-badge">EMAIL ENVIADO</div>
            <p className="forgot-success-text">
              Se existir uma conta associada a este email, enviámos uma ligação para redefinir a palavra-passe.
            </p>
            <p className="forgot-success-note">
              Verifique a sua caixa de entrada e também a pasta de spam.
            </p>
          </div>
        ) : (
          <form className="forgot-form" onSubmit={handleSubmit}>
            <label className="forgot-field">
              <span className="forgot-label">Email</span>
              <div className="forgot-input-wrap">
                <input
                  ref={inputRef}
                  className="forgot-input"
                  type="email"
                  autoComplete="email"
                  inputMode="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={busy}
                  placeholder="nome@empresa.com"
                  required
                />
              </div>
            </label>

            <button type="submit" className="forgot-btn" disabled={busy}>
              <span className="forgot-btn-text">
                {busy ? (
                  <>
                    <span className="forgot-spinner" aria-hidden="true" />
                    A enviar...
                  </>
                ) : (
                  "Enviar ligação de reposição"
                )}
              </span>
            </button>
          </form>
        )}

        <div className="forgot-footer">
          <Link className="forgot-back" to="/">
            Voltar ao iniciar sessão
          </Link>
        </div>
      </div>
    </div>
  );
}